import React, {useEffect, useState} from 'react';
import {getAlert} from "../api/HomeApi";
import {showError} from "../../../utils/toastHelper";

const Alerts = () => {
    const [alert, setAlert] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchSlides = async () => {
            try {
                const params = {
                    serviceApp : 1
                }
                const data = await getAlert(params);
                setAlert(data?.data );
            } catch (err) {
                showError( err);
            } finally {
                setLoading(false);
            }
        };
        fetchSlides();
    }, []);

if (alert.length < 1) {
    return ''
}

    return (
        <React.Fragment>
            <a href={alert.link ? alert.link : '#'} className='d-block alert bg-third-color text-center text-white py-1 mb-0 rounded-0 text-small-2 mt-md-4 text-decoration-none'>
                {alert.text}
            </a>
        </React.Fragment>

    );
};

export default Alerts;
